import React, { useState, useEffect } from 'react';
import AmazonLinkItem from '../common/AmazonLinkItem';
import amazonLinksData from '../../data/amazon_links.json';
import '../../styles/components/sections/AmazonLinksSection.css';

const AmazonLinksSection = ({ title }) => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    setLinks(amazonLinksData);
  }, []);

  if (!links || links.length === 0) {
    return <p>No recommended products available at the moment.</p>;
  }

  return (
    <div className="amazon-links-section">
      {title && <h3 className="amazon-links-title">{title}</h3>}
      <ul className="amazon-links-list">
        {links.map((link, index) => (
          <AmazonLinkItem key={index} name={link.name} url={link.url} />
        ))}
      </ul>
      <p className="amazon-disclaimer">
        As an Amazon Associate, I earn from qualifying purchases.
      </p>
    </div>
  );
};

export default AmazonLinksSection;
